import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { Router, RouterLink, RouterModule } from "@angular/router";
import {
    AllScheduleService,
    EnrollmentScheduleDto,
} from "@malirang/api-client";
import {
    AlertService,
    CalendarEvent,
    Icon,
    ModalAdapter,
    SLIDE_X,
} from "@malirang/front-share";
import { CenterUserStore } from "apps/client/src/stores/center/center-user.store";
import { CenterRoleBadgeComponent } from "../../../../components/center/role-badge/center-role-badge.component";
import { CenterStore } from "../../../../stores/center/center.store";
import { UserStore } from "../../../../stores/user.store";
import { ScheduleHelperService } from "../../../pages/schedule/schedule.helper";

interface Item {
    title: string;
    icon: string;
    link: string;
}

const EventType = {
    PERSONAL: "개인",
    CENTER: "센터",
    TREATMENT: "치료",
    COUNSELING: "상담",
    SUPPLEMENT: "보강",
} as const;

@Component({
    selector: "app-side-menu",
    standalone: true,
    imports: [
        CommonModule,
        Icon,
        RouterModule,
        CenterRoleBadgeComponent,
        RouterLink,
    ],
    templateUrl: "./side-menu.component.html",
    styleUrl: "./side-menu.component.scss",
})
export class SideMenuComponent extends ModalAdapter {
    readonly router = inject(Router);
    readonly userStore = inject(UserStore);
    readonly centerStore = inject(CenterStore);
    readonly allScheduleService = inject(AllScheduleService);
    readonly centerUserStore = inject(CenterUserStore);
    readonly alertService = inject(AlertService);
    readonly scheduleHelperService = inject(ScheduleHelperService);

    user = this.userStore.user;
    center = this.centerStore.currentCenter;

    $todaySchedules = rxResource({
        stream: () => this.allScheduleService.allScheduleControllerFindToday(),
    });
    todaySchedules = this.$todaySchedules.value;
    eventType = EventType;

    menus = signal<Item[]>([
        {
            title: "MY",
            icon: "solar:user-circle-bold-duotone",
            link: "/my-page",
        },
        {
            title: "장바구니",
            icon: "solar:bag-4-bold-duotone",
            link: "/shopping-cart",
        },
        {
            title: "고객지원",
            icon: "solar:call-chat-rounded-bold-duotone",
            link: "/customer",
        },
        {
            title: "설정",
            icon: "solar:settings-bold-duotone",
            link: "/my-page/setting",
        },
        {
            title: "스토어",
            icon: "material-symbols:shopping-bag",
            link: "/store",
        },
    ]);

    /**
     * 일정 목록 캘린더 이벤트로 변환
     */
    schedules = computed<CalendarEvent[]>(() => {
        const events: CalendarEvent[] = [];
        const enrollmentSchedules = this.todaySchedules()?.enrollmentSchedules;
        const schedules = this.todaySchedules()?.schedules;

        if (!this.todaySchedules()) {
            return [];
        }

        enrollmentSchedules?.map((value: EnrollmentScheduleDto) => {
            events.push(
                this.scheduleHelperService.enrollmentScheduleToEvent(value),
            );
        });

        schedules?.map((value) => {
            const centerUserColor =
                this.centerUserStore.currentCenterUser()?.color;
            events.push(
                this.scheduleHelperService.scheduleToEvent(
                    value,
                    value.type === "PERSONAL" ? centerUserColor : undefined,
                ),
            );
        });

        return events;
    });

    logout() {
        this.alertService
            .open({
                title: "로그아웃",
                content: "로그아웃 하시겠습니까?",
                type: "info",
            })
            .closed.subscribe({
                next: (result) => {
                    if (result?.action === "confirm") {
                        this.close();
                        this.userStore.logout();
                    }
                },
            });
    }
}
